<template>
  <div class="sb_upload" :class="{ s_loading: loader }">
    <Button
      @click.native="!disabled && !loader ? $refs.upload.click() : $emit('update:loading', false)"
      class="sb_upload_button"
      type="ghost"
      :disabled="disabled || (loading && !loader)"
    >
      <slot />
      <template #icon-right>
        <transition name="fade" mode="out-in">
          <span v-if="!disabled && loader" class="sb_upload_loader">
            <Spinner class="sb_upload_loader_spinner" />
            <SvgIcon class="sb_upload_loader_cancel" icon="close" />
          </span>
          <SvgIcon v-else class="sb_upload_icon" icon="upload" />
        </transition>
      </template>
    </Button>
    <input ref="upload" type="file" accept=".png, .jpg, .jpeg, .svg" @change="change" hidden />
  </div>
</template>

<script>
export default {
  name: 'Upload',
  props: {
    loading: {
      type: [String, Boolean],
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    change(e) {
      // check if size exceed max size
      const maxSize = window.$store.imagesMaxSize;
      if (maxSize) {
        const bytes = e.target.files[0].size;
        const megaBytes = bytes / (1024 * 1024);
        if (megaBytes > maxSize) {
          this.$emit('error', 'fileSize');
          e.preventDefault();
          return;
        }
      }

      this.$emit('change', e);
      this.$refs.upload.value = '';
    },
  },
  computed: {
    loader() {
      return this.loading && this.loading.includes('custom');
    },
  },
};
</script>

<style lang="scss">
#sb_fotowand-designer {
  .sb_upload {
    &_button {
      position: relative;
    }
    &_loader {
      font-size: 1rem;
      display: block;
      font-weight: 600;
      &_spinner {
        transition: opacity 0.4s;
      }
      &_cancel {
        position: absolute;
        top: 0;
        right: 0;
        color: $brand-red;
        background: $brand-white;
        box-shadow: 0 0 2px 0 rgba($brand-black, 0.2);
        border-radius: 100%;
        padding: 0.3rem;
        transform: translate(50%, -50%);
        font-size: 0.8rem;
        transition: transform 0.4s;
        cursor: pointer;
        will-change: transform;
        &:hover {
          transform: translate(50%, -50%) scale(1.1);
        }
      }
    }
  }
}
</style>
